import { render } from "./MultiSelectCostcentre.vue?vue&type=template&id=68c24dfb"
import script from "./MultiSelectCostcentre.vue?vue&type=script&lang=js"
export * from "./MultiSelectCostcentre.vue?vue&type=script&lang=js"

import "./MultiSelectCostcentre.vue?vue&type=style&index=0&id=68c24dfb&lang=css"

import exportComponent from "/var/www/halisclock/releases/44/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__